<template>
    <div class="div">
        <button class="button is-small text-button" :class="{'bold' : isFilled }" @click="openModal">
            <span>{{ car.proforma_invoice ? car.proforma_invoice.issued_date : '---' }}</span>
            <span class="icon is-success" v-if="isLocked">
                <i class="fas fa-lock"></i>
            </span>
            <span class="icon is-danger" v-else>
                <i class="fas fa-lock-open"></i>
            </span>
        </button>
        <proforma-invoice-modal :car="car" v-if="isActive"></proforma-invoice-modal>
    </div>
</template>

<script>
    import ProformaInvoiceModal from './ProformaInvoice/ProformaInvoiceModal'

    export default {
        props: ['car'],
        components: {
            ProformaInvoiceModal
        },
        computed: {
            isAdmin() {
                return this.$store.getters.checkIfUserIsAdmin
            },
            isLocked() {
                if (this.car.proforma_invoice !== null) {
                    return this.car.proforma_invoice.locked !== null;
                }
            },
            isActive() {
                return this.$store.getters.getProformaInvoiceModalStatus(this.car.id)
            },
            isFilled() {
                if (this.car.proforma_invoice !== null) {
                    return true;
                }
            }
        },
        methods: {
            openModal() {

                this.$store.dispatch('changeProformaInvoiceModalStatus', {status: true, carId: this.car.id})
                this.$store.dispatch('checkProformaInvoice', this.car.id)
                if (this.car.proforma_invoice !== null) {
                    this.$store.dispatch('fetchProformaInvoice', this.car.id)
                }
            }
        }

    }
</script>

<style scoped>
    .is-success {
        color: #00d2b2 !important;
    }

    .is-danger {
        color: #ff3860 !important;
    }

    .text-button {
        min-width: 55px;
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoiceColumn.vue